// Build-time highlighting for docs examples rendered by server components. The server looks up the
// tokens of the examples a page shows (registered by the `*.static-code.ts` modules it imports) and
// passes them, encoded, to the client component that renders the code, which registers them before
// rendering. The browser then gets the tokens of the page's examples only, not whole registries.
import {
  encodeHighlightedCode,
  findHighlightedCode,
  registerHighlightedCode,
  type StaticCodeSample,
} from "src/components/common/Code/HighlightedCode";

/** On the server: the build-time tokens of `samples`, for `registerDocsHighlighting`. */
export const encodeDocsHighlighting = (samples: StaticCodeSample[]): string | undefined => {
  const highlighted = samples.flatMap((sample) => {
    const tokens = findHighlightedCode(sample.value, sample.language, sample.variant);
    return tokens ? [{ ...sample, tokens }] : [];
  });
  return highlighted.length > 0 ? encodeHighlightedCode(highlighted) : undefined;
};

const registered = new Set<string>();

/** In a client component, before rendering the code: registers tokens from the server once. */
export const registerDocsHighlighting = (encoded: string | undefined) => {
  if (!encoded || registered.has(encoded)) return;
  registered.add(encoded);
  registerHighlightedCode(encoded);
};
